import type {JsxVNodeChildren} from 'snabbdom-jsx-lite';

import {portalify} from 'common/util/experimental-portal';
import {isTestEnv} from 'common/report/util/env';

import {TooltipEl, TooltipPanelProps} from './panel';
import {TooltipJsxProps} from './types';

const PortaledTooltip = portalify<TooltipJsxProps>(TooltipEl);

export const ExperimentalTooltipEl = (props?: TooltipPanelProps, children?: JsxVNodeChildren) => {
  if (isTestEnv()) return TooltipEl(props, children);
  const reference = {current: null as HTMLElement | null};
  const node = PortaledTooltip({...props, props: {...props?.props, reference}}, []);
  node.children = TooltipEl(props, children).children;
  const insert = node.data?.hook?.insert;
  const prepatch = node.data?.hook?.prepatch;
  node.data = {
    ...node.data,
    hook: {
      ...node.data?.hook,
      prepatch: (previous, next) => {
        prepatch?.(previous, next);
        const placeholder = previous.data?.attachData?.placeholder;
        reference.current = placeholder instanceof HTMLElement ? placeholder.parentElement : null;
      },
      insert: (vnode) => {
        insert?.(vnode);
        const placeholder = vnode.data?.attachData?.placeholder;
        reference.current = placeholder instanceof HTMLElement ? placeholder.parentElement : null;
      },
    },
  };
  return node;
};
